// File: createRecipe.js (React Component)

import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import PageHeader1 from "../../components/common/PageHeader1";
import { submitScreenApi, getScreenByIdApi } from "../../services/Introscreen";
import { idID } from "@mui/material/locale";

function CreateScreen() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [editorValue, setEditorValue] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (id) {
      (async () => {
        const res = await getScreenByIdApi(id);
        if (res?.data) {
          const r = res.data;
          setValue("title", r.title);
          setValue("subtitle", r.subtitle);
          setImagePreview(`${r.image}`);
        }
      })();
    }
  }, [id, setValue]);

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      imageFile,
      
    };
    if (id) payload._id = id;
    const res = await submitScreenApi(payload);
    if (res) {
      if(!id){
        reset();
        setImageFile(null);
        setImagePreview(null);
      }
      
      
      // if(id) {
      //   navigate("/recipes-list");
      // }
     
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  return (
    <div className="container">
      <PageHeader1
        pagetitle={id ? "Create Screen" : "Add Screen"}
        navigation="Screens"
        navlink="/screens"
        current={id ? "Edit" : "Add"}
      />

      <div className="col-lg-10 mx-auto">
        <div className="card p-4 shadow-sm">
          <form onSubmit={handleSubmit(onSubmit)} className="row g-3">
            <div className="col-12 text-center">
              <h2>{id ? "Edit Screen" : "Add New Screen"}</h2>
            </div>

            <div className="col-md-6">
              <label className="form-label">Image</label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={handleImageChange}
              />
              {imagePreview && (
                <img
                  src={imagePreview}
                  alt="Preview"
                  className="img-thumbnail mt-2"
                  style={{ maxHeight: "200px" }}
                />
              )}
            </div>

            <div className="col-md-6">
              <label className="form-label">Title</label>
              <input
                className="form-control"
                {...register("title", { required: "Title is required" })}
              />
              {errors.title && <p className="text-danger">{errors.title.message}</p>}
            </div>

            <div className="col-12">
              <label className="form-label">Sub Titile</label>
              <input
                className="form-control"
                {...register("subtitle", { required: "Sub Title is required" })}
              />
              {errors.subtitle && <p className="text-danger">{errors.subtitle.message}</p>}
            </div>

            <div className="col-12 text-center mt-4">
              <Button type="submit" className="btn btn-primary px-5 me-3">
                {id ? "Update" : "Save"}
              </Button>
              <Button
                variant="secondary"
                className="px-5"
                onClick={() => navigate("/screens")}
              >
                Back
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateScreen;
